// Libraries
import { ThemeProvider as MuiThemeProvider, createTheme } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { ThemeProvider } from 'styled-components'

// Images
import favicon from '../../../static/steam-img/favicon.ico'

// Components
import Helmet from 'react-helmet'
import RenderFooter from './renderFooter'
import RenderHeader from './renderHeader'

import Announcement from '../global/announcement'
import LocalizedBanner from '../global/localizedBanner'
// Styles
import { GlobalStyle } from '../../styles/global'
import palette from '../../styles/palette'
import typography from '../../styles/typography'

const customizedTheme = createTheme({
  webMktPalette: palette,
  webMktTypography: typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 769,
      md: 1025,
      lg: 1281,
      xl: 1600,
    },
  },
})

const Template = (props: any) => {
  const {
    children,
    lang,
    hideNormalLayout,
    customNav,
    minimalHeader,
    minimalFooter,
    headerData,
    footerData,
    showHeader = true,
    showFooter = true,
    announcementData,
    mainNavBannerData,
    browserLanguageData,
    slug,
    pageType,
    availableLocales,
  } = props

  const [browserLanguage, setBrowserLanguage] = useState('')
  const [currentSlug, setCurrentSlug] = useState(slug)
  const $langCode = lang

  useEffect(() => {
    if (typeof navigator === 'object') {
      const browserLanguage = (navigator.languages && navigator.languages[0]) || navigator.language
      setBrowserLanguage(browserLanguage)
    }
  }, [])

  useEffect(() => {
    const script = document.createElement('script')
    script.src = '/steam-data/des_carry_v_111_min.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  useEffect(() => {
    setCurrentSlug(slug)
  }, [slug, setCurrentSlug])

  /* Common code for execution of hash URLs */
  useEffect(() => {
    var hashId = window.location.hash.slice(1)
    var element = document.getElementById(hashId)
    if (typeof element != 'undefined' && element != null) {
      setTimeout(function () {
        var scrollDiv = element.offsetTop - 100
        window.scrollTo({ top: scrollDiv, behavior: 'smooth' })
      }, 1000)
    }
  }, [])

  return (
    <div data-cy="Layout" lang={lang}>
      <MuiThemeProvider theme={customizedTheme}>
        <ThemeProvider theme={customizedTheme}>
          <GlobalStyle $langCode={$langCode} />
          <Helmet>
            <link rel="icon" href={favicon} />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin={'anonymous'} />
            <link
              rel="preconnect"
              href="https://hubspot-cdn.uipath.com"
              crossOrigin={'anonymous'}
            />
            <link
              rel="preconnect"
              href="https://www.googletagmanager.com"
              crossOrigin={'anonymous'}
            />
          </Helmet>
          <LocalizedBanner
            slug={currentSlug}
            defaultBrowserLanguage={browserLanguage}
            browserLanguageData={browserLanguageData}
            availableLocales={availableLocales}
          />
          <Announcement locale={lang} announcementData={announcementData} page={pageType} />
          {!hideNormalLayout && showHeader && (
            <RenderHeader
              headerData={headerData}
              mainNavBannerData={mainNavBannerData}
              minimalHeader={minimalHeader}
              customNav={customNav}
              locale={lang}
            />
          )}
          {children}
          {!hideNormalLayout && showFooter && (
            <RenderFooter minimalFooter={minimalFooter} footerData={footerData} locale={lang} />
          )}
        </ThemeProvider>
      </MuiThemeProvider>
    </div>
  )
}

export default { Template }
